import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo-white.svg'


const _withScopeId = n => (_pushScopeId("data-v-316b0550"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_2 = { class: "loader" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "loader__icon",
  src: _imports_0,
  alt: "NZGM",
  title: "NZGrapherModern"
}, null, -1))
const _hoisted_4 = { class: "loader__message" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader__ellipsis" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.message), 1),
          _hoisted_5
        ])
      ]))
    : _createCommentVNode("", true)
}